module.exports = __webpack_public_path__ + "img/banner.fa441de2.png";